var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaMontanaCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 402 402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 210.533,
    cy: -321.953,
    r: 168.09,
    gradientTransform: "translate(0 483.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acd46e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30b458"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.492,
    y1: 0.072,
    x2: 0.501,
    y2: 0.565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.508,
    y1: 0.123,
    x2: 0.498,
    y2: 0.515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.59,
    y1: 0.342,
    x2: 0.827,
    y2: -0.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.519,
    y1: 0.204,
    x2: 0.668,
    y2: -0.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.439,
    y1: 0.446,
    x2: 0.398,
    y2: 0.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.503,
    y1: 0.575,
    x2: 0.452,
    y2: 0.158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.594,
    y1: 0.333,
    x2: 0.723,
    y2: 0.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    y1: 0.616,
    x2: 0.5,
    y2: 0.162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.5,
    y1: 0.663,
    x2: 0.5,
    y2: 0.079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.5,
    y1: 0.695,
    x2: 0.5,
    y2: 0.255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.5,
    y1: 0.564,
    x2: 0.5,
    y2: 0.064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    y1: 0.546,
    x2: 0.5,
    y2: 0.223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.5,
    y1: 0.743,
    x2: 0.5,
    y2: 0.288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee2b51"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.275 176.561h6.11L346.454 91.2l-20.249 1.309-.349 11.783-8.379.786-4.8-3.579-.96-7.681-13.441 1.309.698 11.696-5.673.524-3.229-2.182-2.357-8.03-17.544 1.746.786 10.561-10.037.96-3.753-2.706-2.007-7.681-19.987 2.444-1.484 10.561-1.135.087-2.793-3.055-.262-7.244-40.411 3.928.087.611-14.489 1.047-.524 10.212-5.237.524-2.357-2.357-1.571-7.855-17.718 1.92-.786 10.386-5.324.524c-.611-1.047-1.309-2.007-2.095-2.968-3.84-4.451-8.728-6.459-14.663-6.11-4.19.262-7.855 1.484-10.997 3.666-2.968 2.007-5.411 4.888-7.593 8.728l-3.055.262-3.579-1.571.175-4.888-20.337.873-2.182 8.03-4.975.436-3.404-2.531-.262-5.499-20.424.873-8.117 43.641-7.419 23.13 25.312 11.347-2.357 4.888a46.023 46.023 0 0 0-13.267 9.252c-4.713 4.8-8.204 10.125-10.474 15.885-2.444 5.761-3.666 12.219-3.666 19.376 0 9.426 2.095 17.805 6.372 25.224 4.19 7.157 10.474 13.267 18.766 18.155 17.544 10.299 41.895 4.8 46.696 1.397l.087-3.142 11.259-2.269-.524 3.142 34.476-6.546.611-11.783 24.264-4.626 4.975 10.736 30.287-5.761-7.07 17.282c6.372 3.666 12.743 6.372 19.289 8.204 4.539 1.309 9.077 2.095 13.616 2.531v9.688h15.711v-10.299c2.357-.436 4.626-.96 6.721-1.658 5.15-1.658 9.601-4.277 13.529-7.768 3.229-2.793 5.848-6.022 7.768-9.514l10.91 8.641h34.563v-9.863h12.918l8.117-16.409v26.359h34.476v-96.097l-7.332-17.631zm-11.259 121.583h5.237v.786h-2.182v6.284h-.96v-6.284h-2.095v-.786zm12.743.087.436 7.07h-.873l-.262-3.229c-.087-.96-.087-2.182-.087-3.055-.262.786-.524 1.746-.873 2.706l-1.222 3.404h-.698l-1.135-3.317a22.19 22.19 0 0 1-.786-2.706c0 .873-.087 2.095-.175 3.142l-.175 3.055h-.873l.524-7.07h1.135l1.222 3.404c.262.873.524 1.658.698 2.357.175-.698.436-1.484.786-2.357l1.222-3.404h1.135z",
    fill: "#231f20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.663 225.352c-2.88-2.88-6.022-5.062-9.426-6.546-3.317-1.484-6.721-2.269-10.125-2.269-5.499 0-9.95 1.746-13.267 5.15-3.404 3.404-5.062 7.855-5.062 13.529s1.571 10.037 4.8 13.267 7.506 4.8 12.918 4.8c3.229 0 6.546-.698 10.037-2.095 3.579-1.658 7.244-3.84 10.91-6.633l-1.222 35.349c-3.928 1.571-7.593 2.706-10.997 3.229-3.579.786-7.244 1.222-10.997 1.222-4.539 0-8.99-.524-13.267-1.571a41.798 41.798 0 0 1-11.434-4.277c-8.292-4.888-14.576-10.997-18.766-18.155-4.277-7.332-6.372-15.711-6.372-25.224 0-7.244 1.222-13.703 3.666-19.376 2.269-5.848 5.848-11.085 10.474-15.885 4.626-4.626 10.037-8.117 16.147-10.474s12.743-3.491 19.9-3.491c3.753 0 7.506.349 11.347 1.135 3.753.873 7.332 2.007 10.736 3.579v34.738zm10.386 52.281 14.925-95.486 35.785-6.808 48.267 83.441-34.563 6.546-4.975-10.736-24.264 4.626-.611 11.783-34.563 6.633zm36.484-40.586 13.354-2.531-4.713-9.601c-2.357-4.975-4.015-8.815-4.975-11.347a78.22 78.22 0 0 1-2.357-7.593l-.698.087c.436 2.793.611 5.411.611 7.943.087 3.404-.087 7.593-.524 12.394l-.698 10.648zm132.231 41.983v-95.922h34.563v31.945h21.035v-31.945h34.476v95.922h-34.476v-33.778h-21.035v33.778h-34.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.545 234.778c-3.84-4.713-9.077-7.768-15.798-9.252a23.453 23.453 0 0 1-3.579-.873c-9.776-2.007-14.663-4.364-14.663-7.244 0-1.397.611-2.531 1.92-3.404 1.397-.873 3.317-1.309 5.761-1.309 2.968 0 6.284.611 10.037 1.92 3.142 1.222 6.546 3.142 10.037 5.761l10.648-25.573c-5.411-2.968-10.823-5.237-16.409-6.633-4.102-1.135-8.379-1.833-12.83-2.095v-8.204h-18.766v10.125c-5.499 1.658-10.299 4.19-14.401 7.768-7.593 6.721-11.347 15.362-11.347 25.661 0 6.808 1.92 12.481 5.761 16.933 3.928 4.451 9.514 7.681 16.845 9.514 2.007.436 3.753.786 5.237 1.047 6.895 1.484 10.299 3.579 10.299 6.284 0 1.484-.698 2.793-2.007 3.753-1.309.873-3.229 1.309-5.761 1.309-3.404 0-7.07-.786-10.91-2.444-3.753-1.484-8.292-4.102-13.529-7.681l-11.172 27.319c6.372 3.666 12.743 6.372 19.289 8.204 4.539 1.309 9.077 2.095 13.616 2.531v9.688h15.711v-10.299c2.357-.436 4.626-.96 6.721-1.658 5.15-1.658 9.601-4.277 13.529-7.768 7.855-6.808 11.783-15.623 11.783-26.446-.175-6.721-2.095-12.394-6.022-16.933z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m268.512 227.621 17.456-20.337-11.696-8.728z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m78.151 123.058-6.284 22.955-.698 2.531-2.182 7.768-.436-9.252-.087-1.309-1.047-22.257-20.337.873-3.928 21.297-.175.96-7.506 40.586 14.925-.698 6.808-46.434 2.706 46.085 11.783-.524L84 140.427l.262-.96.175-.524-.087.524v.873l-3.579 44.863 14.925-.611 1.658-38.578.087-.96.96-22.868z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.765 122.185c-3.753-4.451-8.641-6.459-14.576-6.022-4.19.262-7.768 1.484-10.91 3.666s-5.761 5.324-7.943 9.426c-2.269 4.277-3.928 9.426-4.975 15.623v.175c-.087.262-.087.611-.175.873a75.764 75.764 0 0 0-.786 17.805c.524 7.855 2.706 14.052 6.546 18.504s8.641 6.546 14.489 6.197c4.19-.262 7.855-1.484 10.997-3.666s5.761-5.324 7.855-9.426c1.658-3.142 2.968-6.721 3.928-10.736l1.484-19.551.087-.96.349-4.539c-.698-7.419-2.793-13.179-6.372-17.369zm-11.085 30.723c-.262 4.364-.786 8.117-1.484 11.259-.524 2.444-1.222 4.19-2.007 5.324s-1.833 1.746-3.055 1.833c-1.309.087-2.357-.436-3.055-1.571s-1.135-2.968-1.309-5.586a83.17 83.17 0 0 1 .087-12.307 72.42 72.42 0 0 1 .96-8.292c.087-.262.087-.611.175-.873.175-.786.262-1.571.436-2.357.524-2.357 1.135-4.102 2.007-5.237s1.92-1.746 3.229-1.833c1.222-.087 2.182.436 2.88 1.658.698 1.135 1.047 3.055 1.222 5.673.087 1.397.175 2.88.175 4.364v.873c0 2.269-.087 4.626-.262 7.07z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m187.602 110.838-14.401 1.047-1.135 23.828-.087.873-.698 14.052-3.142-15.623-.175-.96-4.364-21.559-17.631 1.92-1.833 25.137c0 .436.087.873.087 1.309l.175 2.88v.96c.087 5.062-.262 10.037-1.135 14.925a40.21 40.21 0 0 1-1.047 4.888l-1.571 21.297 15.1-.698 3.928-37.967 7.681 37.444 19.027-.786 2.793-50.885.175-3.753.349-6.721.611-11.87-2.706.262z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m217.714 137.896-.349-14.14 10.91.436-.698-17.893-40.149 3.928.175.611 2.793-.175-.611 11.783.698 3.928 10.299-.873-.087 3.055v.873l-.611 54.551 18.766.262-1.135-45.124z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m263.363 142.696-.262-1.047-9.95-38.142-19.9 2.444-6.197 43.903-.175 1.135-3.666 26.01 17.456.436.436-8.554 12.481-.436 2.88 14.227 17.282-.436-10.386-39.538zm-21.995 11.434.349-4.364.087-1.309 2.182-26.97 4.19 18.94.262.96 2.793 12.83-9.863-.087z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m320.095 181.362-6.11-47.132-.175-1.135-4.626-35.698-13.267 1.309 2.269 38.229v.96l.524 8.554-2.706-9.339-.262-1.047-10.299-35.436-17.456 1.746 2.444 34.913.087 1.397 3.142 43.553 16.758.262-4.102-48.267 13.965 47.394z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m353.437 114.504-6.459-19.726-20.075 1.309-.873 29.588v2.269l-1.658 52.718 17.02.262-1.309-15.1 12.918-.262 3.753 13.965h18.155l-21.471-65.025zm-13.441 34.389-.349-21.122v-.087l-.611-15.623 1.309 4.626 2.095 7.157 6.895 23.479-9.339 1.571z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m74.922 142.609-2.007-1.135-1.135 4.277-.698 2.531-2.182 7.768-.436-9.252-.087-1.309-.262-6.022c-12.219-3.491-19.376 5.411-19.376 5.411l-4.975-3.317-.698 3.84-.175.96-7.506 40.586 14.925-.698 6.808-46.434 2.706 46.085 11.783-.524 12.307-45.212.262-.96.175-.524-.087.524v.873l-3.579 44.863 14.925-.611 1.658-38.578.087-.96.175-3.579c-13.354-7.332-22.606 1.397-22.606 1.397z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m127.204 145.751-.262 7.157c-.262 4.364-.786 8.117-1.484 11.259-.524 2.444-1.222 4.19-2.007 5.324s-1.833 1.746-3.055 1.833c-1.309.087-2.357-.436-3.055-1.571s-1.135-2.968-1.309-5.586a83.17 83.17 0 0 1 .087-12.307c.175-2.968.524-5.586.96-8.117-4.975-1.309-8.03-2.706-8.03-2.706l-9.077 2.095c-.087.611-.262 1.135-.349 1.746v.175c-.087.262-.087.611-.175.873a75.764 75.764 0 0 0-.786 17.805c.524 7.855 2.706 14.052 6.546 18.504s8.641 6.546 14.489 6.197c4.19-.262 7.855-1.484 10.997-3.666s5.761-5.324 7.855-9.426c1.658-3.142 2.968-6.721 3.928-10.736l1.484-19.027a63.7 63.7 0 0 1-16.758.175z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.652 136.935s-2.357-6.11-4.975-8.466l-.349 7.157-.087.873-.698 14.052-3.142-15.623-.175-.96-.698-3.666c-4.626 4.102-16.758 10.125-22.868 13.005v1.222c.087 5.062-.262 10.037-1.135 14.925a40.21 40.21 0 0 1-1.047 4.888l-1.571 21.297 15.1-.698 3.928-37.967 7.681 37.444 19.027-.786 2.793-50.885.175-3.753.349-6.721.175-2.618c-6.721 2.531-12.481 17.282-12.481 17.282z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.695 128.818v.698l-.611 54.551 18.766.262-1.135-45.124v-1.222l-.087-2.444c-7.419-6.721-13.005-7.855-16.933-6.721z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m263.363 142.696-.262-1.047-.698-2.531c-13.267-4.626-5.237-1.571-13.005 6.895l1.746 8.204h-9.863v-.087l.175-2.269c-5.935 2.444-10.736-.262-14.227-3.84l-.262 1.833-.175 1.135-3.666 26.01 17.456.436.436-8.554 12.481-.436 2.88 14.227 17.282-.436-10.299-39.538z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m300.283 181.624 19.813-.262-4.713-36.396c-5.324 4.19-11.259 3.404-16.671.698l-.175-.087c-4.19-2.095-8.117-5.324-11.172-8.03l-.786-.698c-3.404-3.055-5.586-5.237-5.586-4.015 0 2.095-5.15 6.372-10.125 10.125l2.793 39.189 16.758.262-3.84-45.474.873.873 12.83 43.815z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M353.786 115.377c-4.015 2.007-7.855 5.499-11.085 9.077l6.721 22.955-9.339 1.571-.349-21.035c-3.753 4.713-6.197 8.815-6.197 8.815-.349-2.618-3.666-5.673-7.506-8.292l-1.658 52.369 17.02.262-1.309-15.1 12.918-.262 3.753 13.965h18.155l-21.122-64.326z",
    fill: "url(#k)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaMontanaCash);
export default __webpack_public_path__ + "static/media/usa_montana_cash.13552d10bbce27f72c7fd8bced56efca.svg";
export { ForwardRef as ReactComponent };